function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTypescript = function SvgIconTypescript(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface2737238"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "currentColor",
      fillOpacity: 1
    },
    d: "M 45 4 L 5 4 C 4.445312 4 4 4.449219 4 5 L 4 45 C 4 45.550781 4.445312 46 5 46 L 45 46 C 45.554688 46 46 45.550781 46 45 L 46 5 C 46 4.449219 45.554688 4 45 4 Z M 29 26.445312 L 24 26.445312 L 24 42 L 20 42 L 20 26.445312 L 15 26.445312 L 15 23 L 29 23 Z M 30.121094 41.113281 L 30.121094 36.953125 C 30.121094 36.953125 32.390625 38.664062 35.117188 38.664062 C 37.84375 38.664062 37.738281 36.882812 37.738281 36.640625 C 37.738281 34.054688 30.015625 34.054688 30.015625 28.324219 C 30.015625 20.535156 41.265625 23.609375 41.265625 23.609375 L 41.125 27.3125 C 41.125 27.3125 39.238281 26.054688 37.109375 26.054688 C 34.976562 26.054688 34.207031 27.066406 34.207031 28.148438 C 34.207031 30.945312 42 30.664062 42 36.289062 C 42 44.953125 30.121094 41.113281 30.121094 41.113281 Z M 30.121094 41.113281 "
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTypescript, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-typescript.5363ba28.svg";
export { ForwardRef as ReactComponent };